import React, { Component } from 'react'
import { withTheme } from 'styled-components'
import moment from 'moment'

import { toAbsCurrency } from '../../../Utils/util'
import TableView from '../../Reusable/TableView'
import environment from '../../../environment'
import { Popconfirm } from 'antd'
import { TextButton } from '../../Reusable/Button'

class BillPaymentScheduledTable extends Component {

    render() {

        var { payments } = this.props

        var columns = [
            {
                title: 'Created',
                dataIndex: 'date',
                render: date => date
            },
            {
                title: 'Amount',
                dataIndex: 'amount',
                render: amt => `$${toAbsCurrency(amt, 2)}`
            },
            {
                title: 'Status',
                dataIndex: 'status',
                render: (status, item) => {
                    if(status == "pending_approval") return "Pending Approval"
                    else {
                        return (
                            <div className='cell-content'>
                                <span className='hide-on-hover'>{status}</span>
                                <Popconfirm
                                    title={`Are you sure you want to cancel this scheduled payment?`} 
                                    okText='Yes'
                                    cancelText='No'
                                    onClick={(e) => e.stopPropagation()} 
                                    onConfirm={(e) => { 
                                                    e.stopPropagation()
                                                    this.props.cancelBillPayment(item.paymentId)
                                                }} 
                                    onCancel={(e) => { e.stopPropagation() }}
                                >
                                    <TextButton
                                        className='show-on-hover'
                                        title={'Cancel Payment - ' + status}
                                        text='CANCEL'
                                    /> 
                                </Popconfirm>
                            </div>
                        )
                    }
                },
                width: '220px'
            }
        ]
        
        return (
            <TableView
                id='bill-payments-table'
                tableLayout='auto'
                columns={columns}
                dataSource={payments}
                rowKey='paymentId'
                titleText={this.props.titleText || 'In Progress'}
                descText={this.props.descText || 'These payments are scheduled or pending approval'}
                borderView={this.props.borderView}
            />
        )
    }
}

export default withTheme(BillPaymentScheduledTable)